module.exports = __webpack_public_path__ + "static/img/bg55.25271736.png";